import { TableHeader } from '../../clientModule/components/Common/Table/types';

export const filterMeta = [
  { label: 'Document Name', name: 'documentName' },
  { label: 'Document Type', name: 'wikiDocumentTypeName' },
  { label: 'File', name: 'permittingVisibleFilename' },
];

export const headers: TableHeader[] = [
  {
    label: 'Topic',
    sortingKey: 'topicTitle',
    itemName: 'topicTitle',
  },
  {
    label: 'Category',
    sortingKey: 'categoryTitle',
    itemName: 'categoryTitle',
  },
  {
    label: 'Note',
    sortingKey: 'note',
    itemName: 'note',
    isHtml: true,
  },
  {
    label: 'Modified By',
    sortingKey: 'modifiedBy',
    itemName: 'modifiedBy',
  },
  { label: 'Detail', hideFilter: true, itemName: '' },
];
